import React from 'react';
import { useTranslation } from 'react-i18next';
import settingsIcon from './settings.svg';
import css from './show-settings.module.css';

interface Props {
  onClick: () => void;
  id?: string;
}

export default function ShowSettings({ onClick, id = null }: Props) {
  const { t } = useTranslation();

  return (
    <div
      id={id}
      onClick={() => {
        onClick();
      }}
      className={css['container']}
    >
      <img src={settingsIcon} alt="" />
      <h1 className={css['settings-text']}>
        {t('pages.livestock.animals_and_events.animal_settings.settings')}
      </h1>
    </div>
  );
}
